import { createFileRoute } from "@tanstack/react-router";
import { Box, Paper } from "@mui/material";
import { useQuickStart } from "@/pages/organizations/detail/quick-start";
import YourGuides from "@/features/guides/components/quick-start/YourGuides";
import GuideStepper from "@/features/guides/components/quick-start/GuideStepper";
import StepZero from "@/features/guides/components/quick-start/Step0";

export const Route = createFileRoute("/app/organizations/$organizationId/quick-start/")({
  component: RouteComponent,
});

const steps = ["Select Topic", "Answer Questions", "Get Your Guide"];

function RouteComponent() {
  const { userCanEditAssessments, scrollRefStartGuide, createGuideAndNavigate } = useQuickStart();

  const activeStep = 0;
  const isStepSkipped = () => false;
  const handleBack = () => {};

  return (
    <>
      <YourGuides />
      <Box ref={scrollRefStartGuide}>
        {userCanEditAssessments && (
          <>
            <Box component="h2">Start a New Guide</Box>
            <Paper variant="elevation" elevation={5}>
              <GuideStepper
                activeStep={activeStep}
                handleBack={handleBack}
                steps={steps}
                isStepSkipped={isStepSkipped}
              />
              <StepZero onNext={createGuideAndNavigate} />
            </Paper>
          </>
        )}
      </Box>
    </>
  );
}
